import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { RiderService, ConfigService, AppDataService } from 'app/services';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import {
    LastActiveTypeModel, BackOfficeEnum, RiderVehicleTypeEnum,
    ServiceTypeEnum, MenuPermissionActionEnum, DriverCampaignType, BetaFeature, FieldTypeEnum
} from 'app/models';
import { MenuHomeEnum } from 'app/components/home';
import { AppComponent } from 'app/app.component';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'drivers-compaign-xpress50',
    templateUrl: './drivers-compaign-xpress50.component.html',
    styleUrls: ['./drivers-compaign-xpress50.component.scss',
        '../../../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class DriversCompaignXpress50Component implements OnInit {
    public backOfficeActive!: BackOfficeEnum;
    public driverCampaignTypeEnum = DriverCampaignType;

    @Input()
    public campaignType!: DriverCampaignType;

    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public loading: boolean = false;
    public fieldTypeEnum = FieldTypeEnum;
    public tableName: string = this.app.backOfficeRoot.getDriverType() + '-' +
        this.app.backOfficeRoot.getMenuValue();

    @Input()
    set _backOfficeActive(value: BackOfficeEnum) {
        if (this.backOfficeActive) {
            this.backOfficeActive = value;
            this.callBackOfficeForFilter(this.backOfficeActive);
            this.driverHeaderSearch = [];
            this.handleLazyLoad({
                first: 0,
                rows: this.rowsPerPage
            });
        } else {
            this.backOfficeActive = value;
            this.callBackOfficeForFilter(this.backOfficeActive);
        }
    }

    public menuHomeEnumActive!: MenuHomeEnum;
    @Input()
    set _menuHomeEnumActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive = value;
    }

    public riders: Array<any> = [];
    public cols: any[] = [];
    public defaultCols: any[] = [];

    // Grid settings
    public rowsPerPage: number = Utils.getRowsPerPageCount();
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;
    public skip: number = 0;
    public hasAccessToReward4w: boolean = false;

    public filter: {
        searchName: string;
    } = { searchName: '' };

    public driverHeaderSearch: any = {
        riderId: null,
        userName: null,
        isOnline: null,
        countTrips: null,
        acceptanceRate: null,
        cancellationRate: null,
        completeRate: null,
        earningSum: null,
        commissionSum: null,

        createdAt: null,
        onlineAt: null,
        lastActiveTypeObj: null,
        tripLocation: null
    };

    private searchTimer: number = 0;

    public selectedDriver: any;
    public visibleDetail: boolean = false;
    public visibleRiderReward4wIncentive: boolean = false;

    public driverVehicleTypes: any[] = [];
    public driverServiceTypes: any[] = [];
    public lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;
    public onlineStatuses = [
        { name: 'All', value: null },
        { name: 'Online', value: true },
        { name: 'Offline', value: false }
    ];

    public selectedDateRange: Date[] = [];

    public showDriversCompaignExportSidebar: boolean = false;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Drivers' },
        { label: this.app.backOfficeRoot.getDriverType() },{ label: this.app.backOfficeRoot.getMenuValue() }];

    constructor(
        private messageService: MessageService,
        private riderService: RiderService,
        public app: AppComponent,
        public appData: AppDataService,
        public configService: ConfigService) {
        this.handleHideRiderReward4W = this.handleHideRiderReward4W.bind(this);
        this.hasAccessToReward4w = this.appData.betaFeaturesIsExist([BetaFeature.Reward4wRxpRider]);
    }

    ngOnInit(): void {
        this.selectedDateRange[0] = new Date();
        this.selectedDateRange[1] = new Date();
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        this.skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.tableName = this.app.backOfficeRoot.getDriverType() + '-' + this.app.backOfficeRoot.getMenuValue();
        this.loadColumnSelectorSettings();
        this.callBoardingTitles(this.skip);
        this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Drivers' },
            { label: this.app.backOfficeRoot.getDriverType() },{ label: this.app.backOfficeRoot.getMenuValue() }];
    }

    loadColumnSelectorSettings() {
        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.app.backOfficeRoot.getDriverType() + '-' +
                this.app.backOfficeRoot.getMenuValue());
        }
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public changeDateRange() {
        if (!this.selectedDateRange[1]) {
            return;
        }
        this.getCompaignXpress50Riders(0);
    }

    private callBoardingTitles(skip: number) {
        if (this.campaignType === DriverCampaignType.Xpress50Rider4W) {
            this.cols = [
                { field: 'RiderId', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
                    placeholder: 'Type here', header: 'Driver ID', width: '20%', active: false },
                { field: 'UserName', fieldType: FieldTypeEnum.Inputs, model: 'userName',
                    placeholder: 'Type here', header: 'Name', width: '20%', active: false },
                { field: 'Status', fieldType: FieldTypeEnum.Dropdown, options: this.onlineStatuses, model: 'isOnline',
                    placeholder: 'Please Select', header: 'Status', width: '20%', active: false },
                { field: 'CountTrips', fieldType: FieldTypeEnum.InputNumber, model: 'countTrips',
                    placeholder: 'Type here', header: 'No of Trips', width: '20%', active: false },
                { field: 'AcceptanceRate', fieldType: FieldTypeEnum.InputNumber, model: 'acceptanceRate',
                    placeholder: 'Type here', header: 'Accep. Rate', width: '20%', active: false },
                { field: 'CancellationRate', fieldType: FieldTypeEnum.InputNumber, model: 'cancellationRate',
                    placeholder: 'Type here', header: 'CXL Rate', width: '20%', active: false },
                { field: 'CompleteRate', fieldType: FieldTypeEnum.InputNumber, model: 'completeRate',
                    placeholder: 'Type here', header: 'Comp. Rate', width: '20%', active: false },
                { field: 'XpressEarningAmount', fieldType: FieldTypeEnum.InputNumber, model: 'earningSum',
                    placeholder: 'Type here', header: 'Xpress Earnings', width: '20%', active: false },
                { field: 'TotalActivity', fieldType: FieldTypeEnum.Dropdown, model: 'lastActiveTypeObj', options: this.lastActiveTypeList,
                    placeholder: 'Type here', header: 'Online Hours', width: '20%', take: 'obj', active: false },
            ];
        }
        else {
            this.cols = [
                { field: 'RiderId', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
                    placeholder: 'Type here', header: 'Driver ID', width: '20%', active: false },
                { field: 'UserName', fieldType: FieldTypeEnum.Inputs, model: 'userName',
                    placeholder: 'Type here', header: 'Name', width: '20%', active: false },
                { field: 'Status', fieldType: FieldTypeEnum.Dropdown, options: this.onlineStatuses, model: 'isOnline',
                    placeholder: 'Please Select', header: 'Status', width: '20%', active: false },
                { field: 'CountTrips', fieldType: FieldTypeEnum.InputNumber, model: 'countTrips',
                    placeholder: 'Type here', header: 'No of Trips', width: '20%', active: false },
                { field: 'AcceptanceRate', fieldType: FieldTypeEnum.InputNumber, model: 'acceptanceRate',
                    placeholder: 'Type here', header: 'Accep. Rate', width: '20%', active: false },
                { field: 'CancellationRate', fieldType: FieldTypeEnum.InputNumber, model: 'cancellationRate',
                    placeholder: 'Type here', header: 'CXL Rate', width: '20%', active: false },
                { field: 'CompleteRate', fieldType: FieldTypeEnum.InputNumber, model: 'completeRate',
                    placeholder: 'Type here', header: 'Comp. Rate', width: '20%', active: false },
                { field: 'EarningSum', fieldType: FieldTypeEnum.InputNumber, model: 'earningSum',
                    placeholder: 'Type here', header: 'Earnings', width: '20%', active: false },
                { field: 'CommissionSum', fieldType: FieldTypeEnum.InputNumber, model: 'commissionSum',
                    placeholder: 'Type here', header: 'Commission', width: '20%', active: false },
            ];
        }

        this.defaultCols = this.cols.map(x => x);
        this.getCompaignXpress50Riders(skip);
    }

    getCompaignXpress50Riders(skip: number) {
        const dto = {
            StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
            EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),

            SearchName: this.filter.searchName,

            RiderId: this.driverHeaderSearch.riderId,
            UserName: this.driverHeaderSearch.userName,
            IsOnline: this.driverHeaderSearch.isOnline,
            CountTrips: this.driverHeaderSearch.countTrips,
            AcceptanceRate: (this.driverHeaderSearch.acceptanceRate) ? this.driverHeaderSearch.acceptanceRate : null,
            CancellationRate: (this.driverHeaderSearch.cancellationRate) ? this.driverHeaderSearch.cancellationRate : null,
            CompleteRate: (this.driverHeaderSearch.completeRate) ? this.driverHeaderSearch.completeRate : null,
            EarningSum: this.driverHeaderSearch.earningSum,
            CommissionSum: this.driverHeaderSearch.commissionSum,

            CreatedAt: (this.driverHeaderSearch.createdAt) ? moment(this.driverHeaderSearch.createdAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            OnlineAt: (this.driverHeaderSearch.onlineAt) ? moment(this.driverHeaderSearch.onlineAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            LastActiveType: (this.driverHeaderSearch.lastActiveTypeObj) ? this.driverHeaderSearch.lastActiveTypeObj.value : null,
            LastActiveAt: (this.driverHeaderSearch.lastActiveTypeObj && this.driverHeaderSearch.lastActiveTypeObj.dateTime) ?
                moment(this.driverHeaderSearch.lastActiveTypeObj.dateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            ServiceTypes: this.driverServiceTypes,
            VehicleTypes: this.driverVehicleTypes,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            CampaignType: this.campaignType
        };

        this.loading = true;
        this.riderService.getCompaignXpress50Riders(dto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.riders = data.Items;
                this.riders.forEach(item => {
                    item.Status = (item.IsOnline) ? 'Online' : 'Offline';
                    item.StatusColor = '#fff';
                    item.StatusBgColor = (item.IsOnline) ? '#1CBA70' : '#ff0000';
                    item.AcceptanceRate = item.AcceptanceRate + '%';
                    item.CancellationRate = item.CancellationRate + '%';
                    item.CompleteRate = item.CompleteRate + '%';

                    if (this.campaignType === DriverCampaignType.Xpress50Rider4W) {
                        item.XpressEarningAmount = '₱' + item.XpressEarningAmount;
                    }
                    else {
                        item.EarningSum = '₱' + item.EarningSum;
                        item.CommissionSum = '₱' + item.CommissionSum;
                    }
                });
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public addOrRemoveRiderCampaign(riderObj: any) {
        if (this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create) ||
            this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Delete)) {
            const dto = {
                RiderId: riderObj.RiderId,
                IsBelongXpress50: this.campaignType === DriverCampaignType.Xpress50 ? false : null,
                IsXpress50Rider4W: this.campaignType === DriverCampaignType.Xpress50Rider4W ? false : null,
                IsEVDriver: (this.campaignType === DriverCampaignType.Xpress2WEV || this.campaignType === DriverCampaignType.Xpress4WEV) ? false : null,
                IsAllanGroup: (this.campaignType === DriverCampaignType.AllanGroup) ? false : null,
                IsNiloGroup: (this.campaignType === DriverCampaignType.NiloGroup) ? false : null
            };
            this.riderService.addOrRemoveRiderCampaign(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rider remove from campaign' });
                    this.getCompaignXpress50Riders(this.skip);
                });
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getCompaignXpress50Riders(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleShowDriverInfo(driver: any) {
        this.selectedDriver = driver;
        this.visibleDetail = true;
    }
    changedVisibleDetailEmit(value: any) {
        this.visibleDetail = value;
        this.getCompaignXpress50Riders(this.skip);
    }

    public handleShowDriversCompaignExportSidebar() {
        this.showDriversCompaignExportSidebar = true;
    }
    changedShowDriversCompaignExportSidebarEmit(value: any) {
        this.showDriversCompaignExportSidebar = value;
    }

    callBackOfficeForFilter(backOffice: BackOfficeEnum) {
        switch (backOffice) {
            case BackOfficeEnum.Passenger2W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Passenger3W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.ETrike];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Passenger4W:
                this.driverVehicleTypes = [
                    RiderVehicleTypeEnum.Sedan,
                    RiderVehicleTypeEnum.SUV,
                    RiderVehicleTypeEnum.Fastest,
                    RiderVehicleTypeEnum.PetTaxi,
                    RiderVehicleTypeEnum.Courier,
                    RiderVehicleTypeEnum.Cargo,
                    RiderVehicleTypeEnum.Van,
                    RiderVehicleTypeEnum.Minibus,
                    RiderVehicleTypeEnum.Multicab,
                    RiderVehicleTypeEnum.EVCar
                ];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Delivery2W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
                    ServiceTypeEnum.Grocery];
                break;
            case BackOfficeEnum.Delivery4W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Sedan,
                RiderVehicleTypeEnum.SUV,
                RiderVehicleTypeEnum.Fastest,
                RiderVehicleTypeEnum.PetTaxi,
                RiderVehicleTypeEnum.Courier,
                RiderVehicleTypeEnum.Cargo,
                RiderVehicleTypeEnum.Van,
                RiderVehicleTypeEnum.Minibus,
                RiderVehicleTypeEnum.Multicab,
                RiderVehicleTypeEnum.EVCar];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
                    ServiceTypeEnum.Grocery];
                break;
            default:
                this.driverVehicleTypes = [];
                this.driverServiceTypes = [];
                break;
        }
    }

    public handleShowRiderReward4W() {
        this.visibleRiderReward4wIncentive = true;
    }

    public handleHideRiderReward4W(): void {
        this.visibleRiderReward4wIncentive = false;
    }
}
